import { api } from '@/lib/api';

export type NotificationKind = 'assigned' | 'rescheduled' | 'cancelled' | 'removed' | 'updated' | 'completed';

export interface NotificationRow {
  id: string;
  kind: NotificationKind;
  title: string;
  body: string;
  // Only the entity id; the route is derived client-side (see notification-routing.ts).
  data: { jobId?: string };
  jobNumber: string | null;
  assetLabel: string | null;
  start: string | null;
  end: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationFeed {
  data: NotificationRow[];
  nextCursor: string | null;
  unseenCount: number;
}

export async function registerDeviceToken(token: string, platform: 'ios' | 'android') {
  return api('/notifications/device-tokens', {
    method: 'POST',
    body: JSON.stringify({ token, platform }),
  });
}

export async function deleteDeviceToken(token: string) {
  return api(`/notifications/device-tokens/${encodeURIComponent(token)}`, { method: 'DELETE' });
}

export async function fetchNotifications(cursor?: string): Promise<NotificationFeed> {
  const qs = new URLSearchParams({ limit: '20', ...(cursor ? { cursor } : {}) });
  const res = await api<NotificationRow[]>(`/notifications?${qs.toString()}`);
  const meta = res as { nextCursor?: string | null; unseenCount?: number };
  return {
    data: res.data ?? [],
    nextCursor: meta.nextCursor ?? null,
    unseenCount: meta.unseenCount ?? 0,
  };
}

export async function markSeen() {
  return api('/notifications/mark-seen', { method: 'POST' });
}

export async function markRead(id: string) {
  return api(`/notifications/${id}/read`, { method: 'PATCH' });
}

export async function markAllRead() {
  return api('/notifications/read-all', { method: 'POST' });
}
